export default "__VITE_PUBLIC_ASSET__fb5a059c__"